import axios from '../../axios'

export default {
  SET_BEARER(state, accessToken) {
    try {
      state.accessToken = accessToken
    } catch (error) {

    }
  },
  SET_USER(state, user) {
    state.user.id = user.id;
    state.user.name = user.names;
    state.user.numberId = user.numberId;
    state.user.email = user.email;
    state.user.email_verified_at = user.email_verified_at;
    state.user.language = user.language;
  },
  UPDATE_CODE(state,code){
    state.code = code
  }
}
